import React from "react";
import { Button } from "./button";
import { Save } from "lucide-react";
import useWordpressSettings from "@/hooks/useWordpressSettings";
import { useSettingsState } from "@/context/SettingsStateContext";

export const FloatingSaveButton: React.FC = () => {
  const { handleSave } = useWordpressSettings();
  const { isSaving } = useSettingsState();

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={handleSave}
        disabled={isSaving}
        className="shadow-lg hover:shadow-xl transition-all duration-200"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  );
};
